import React from 'react';
import 'components/styles/footer.css';
import { ReactComponent as MajidFooterLogo } from 'assets/images/majid-footer-logo.svg';

const Footer = () => {
  const currentYear = (new Date()).getFullYear();
  return (
    <footer>
      <div className="footer-container">
        <div className="logoFooter">
          <MajidFooterLogo/>
        </div>
        <div className="copyright"> © {currentYear} All rights reserved, Majid Al Futtaim</div>
      </div>
    </footer>
  );
};

export default Footer;
